import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Sidebar = ({ collapsed, toggleSidebar }) => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = async (e) => {
    e.preventDefault();
    if (!localStorage.getItem("access")) return;
    const refresh = localStorage.getItem("refresh");

    try {
      const res = await fetch(`${BASE_URL}/users/logout/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
        body: JSON.stringify({ refresh }),
      });

      if (res.ok) {
        localStorage.removeItem("access");
        localStorage.removeItem("refresh");
        window.location.reload();
      } else {
        const data = await res.json();
        toast.error(data.error || "Logout failed");
      }
    } catch {
      toast.error("Logout failed. Try again.");
    }
  };

  const menuItems = [
    { path: "/dashboard", icon: "fas fa-th-large", label: "Dashboard" },
    { path: "/profile", icon: "fas fa-user", label: "My Profile" },
    { path: "/courses", icon: "fas fa-graduation-cap", label: "Courses" },
    { path: "/enrolled-courses", icon: "fas fa-graduation-cap", label: "Enrolled Courses" },
    { path: "/wishlist", icon: "fas fa-bookmark", label: "Wishlist" },
    { path: "/quiz-attempts", icon: "fas fa-clipboard-list", label: "My Quiz Attempts" },
    { path: "/questions", icon: "fas fa-question-circle", label: "Question & Answer" },
    { path: "/settings", icon: "fas fa-cog", label: "Settings" },
  ];

  return (
    <>
      <div className={`sidebar ${collapsed ? "collapsed" : ""} ${isMobile && !collapsed ? "show-mobile" : ""}`}>
        <div className="sidebar-content">
          <nav className="sidebar-nav">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`sidebar-item ${location.pathname === item.path ? "active" : ""}`}
                onClick={isMobile ? toggleSidebar : undefined}
              >
                <i className={`${item.icon} sidebar-icon`}></i>
                <span className="sidebar-label">{item.label}</span>
              </Link>
            ))}
            <a href="#" onClick={handleLogout} className="sidebar-item">
              <i className="fas fa-sign-out-alt sidebar-icon"></i>
              <span className="sidebar-label">Logout</span>
            </a>
          </nav>
        </div>
      </div>

      {/* Mobile overlay */}
      {isMobile && !collapsed && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}
    </>
  );
};

export default Sidebar;
